import { render, staticRenderFns } from "./FabuCaigou.vue?vue&type=template&id=327e4354&scoped=true"
import script from "./FabuCaigou.vue?vue&type=script&lang=js"
export * from "./FabuCaigou.vue?vue&type=script&lang=js"
import style0 from "./FabuCaigou.vue?vue&type=style&index=0&id=327e4354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e4354",
  null
  
)

export default component.exports